import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { StorageLocationsService } from '../storage-locations.service';
import { AddStorageLocations } from '../storage-locations.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-add-storage-locations',
    templateUrl: './add-storage-locations.component.html',
    styleUrls: ['./add-storage-locations.component.scss'],
})
export class AddStorageLocationsComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    serverOptions: { name: string; id: number }[] = [
        {
            name: '--Alegeți--',
            id: -1,
        },
        {
            name: 'Same server',
            id: 1,
        },
        {
            name: 'Remote server',
            id: 1,
        }
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        location_path: new FormControl('', [Validators.required]),
        location_server: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        ip: new FormControl('', []),
        port: new FormControl('', []),
        observatii: new FormControl('', []),
    });

    constructor(
        private dialogRef: MatDialogRef<AddStorageLocationsComponent>,
        private requestService: StorageLocationsService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const payload: AddStorageLocations = {
            name: this.form.get('name')?.value,
            slug: this.form.get('slug')?.value,
            location_path: this.form.get('location_path')?.value,
            location_server: this.form.get('location_server')?.value,
            ip: this.form.get('ip')?.value,
            port: this.form.get('port')?.value,
            observatii: this.form.get('observatii')?.value,
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
